import { CommonModule } from '@angular/common';
import {
  ChangeDetectionStrategy,
  Component,
  inject,
  input,
  output,
} from '@angular/core';
import { FormGroup, ReactiveFormsModule } from '@angular/forms';

import { FormService } from '../form.service';

@Component({
  selector: 'plugins-form',
  imports: [CommonModule, ReactiveFormsModule],
  templateUrl: './form.component.html',
  styleUrl: './form.component.scss',
  providers: [FormService],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FormComponent<T> {
  readonly formGroup = input.required<FormGroup>();
  readonly classStyle = input<string | undefined>();

  readonly submitted = output<T>();
  readonly invalidSubmit = output<T>();

  protected formService = inject(FormService);

  validate() {
    return this.formService.checkFormValidity(this.formGroup());
  }

  onSubmit() {
    if (this.validate()) {
      this.submitted.emit(this.formGroup().getRawValue() as T);
    } else {
      this.invalidSubmit.emit(this.formGroup().getRawValue() as T);
    }
  }
}
